<template>
  <div class="viewRecord">
    <el-card>
      <el-row :gutter="20">
              <el-col :span="4">
                  <el-input
                    style="width: 100%;"
                    v-model="searchForm.name"
                    placeholder="请输入手机号/学员姓名"
                    auto-complete="off"
                    clearable
                  ></el-input>
              </el-col>
              <el-col :span="6">
                <el-button
                  type="primary"
                  @click="pageList"
                  icon="el-icon-search"
                >搜索</el-button>
              </el-col>
            </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        v-loading="tableLoading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
      >
        <el-table-column prop="studentName" label="学员姓名"></el-table-column>
        <el-table-column prop="mobile" label="手机"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop label="辅助功能" width="150" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <el-button type="text" @click="historyFormShow(scope.row)">观看记录</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>
    <el-dialog title="观看记录" :visible.sync="historyFormVisible" width="800px" left :close-on-click-modal="false">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="往期体验" name="first">
          <el-table
            ref="multipleTable"
            :data="historyPage.rows"
            tooltip-effect="dark"
            style="margin-top: 20px; width: 100%;"
            border
            v-loading="historyTableLoading"
            element-loading-text="拼命加载中"
            
            element-loading-background="rgba(255, 255, 255, 0.8)"
          >
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="courseName" label="课程名"></el-table-column>
            <el-table-column prop="liveInfoName" label="直播名"></el-table-column>
            <el-table-column prop="createTime" label="观看时间"></el-table-column>
            <el-table-column prop="createTime" label="观看时长"></el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            style="margin-top: 20px;text-align: right;"
            :total="historyPage.total"
            :page-size="historyPage.pageSize"
            :current-page="historyPage.pageNumber"
            @size-change="historySizeChange"
            @current-change="historyCurrentChange"
          ></el-pagination>
        </el-tab-pane>
        <el-tab-pane label="已报课程" name="second">
            <el-table
        
        ref="multipleTable"
        :data="subjectPage.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        v-loading="subjectTableLoading"
        element-loading-text="拼命加载中"
        
        element-loading-background="rgba(255, 255, 255, 0.8)"
      >
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="mobile" label="课程名"></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px;text-align: right;"
        :total="subjectPage.total"
        :page-size="subjectPage.pageSize"
        :current-page="subjectPage.pageNumber"
        @size-change="subjectSizeChange"
        @current-change="subjectCurrentChange"
      ></el-pagination>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableLoading: false,
      historyTableLoading: false,
      subjectTableLoading: false,
      searchForm: {},
      recordSearchForm: {},
      enterCourseSearchForm: {},
      activeName: "first",
      historyFormVisible: false,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "asc"
      },
      historyPage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "asc"
      },
      subjectPage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "asc"
      },
    };
  },
  methods: {
    historySizeChange(pageSize) {
      this.historyPage.pageSize = pageSize;
      this.recordPageList();
    },
    historyCurrentChange(pageNumber) {
      this.historyPage.pageNumber = pageNumber;
      this.recordPageList();
    },
    subjectSizeChange(pageSize) {
      this.subjectPage.pageSize = pageSize;
      this.enterCourseSearchForm();
    },
    subjectCurrentChange(pageNumber) {
      this.subjectPage.pageNumber = pageNumber;
      this.enterCourseSearchForm();
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    pageList() {
      this.tableLoading = true;
      this.searchForm.objectId = this.$route.query.id;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.liveLog
        .pageList(this.searchForm)
        .then(result => {
          if (result.success) {
            this.page.rows = result.data.records;
            this.page.total = result.data.total;
            this.tableLoading = false;
          } else {
            this.$message.error(result.message);
            this.tableLoading = false;
          }
        })
        .catch(error => {
          this.tableLoading = false;
          console.log(error);
        });
    },
    recordPageList() {
      this.historyTableLoading = true;
      this.recordSearchForm.studentId = this.studentId;
      this.recordSearchForm.pageSize = this.historyPage.pageSize;
      this.recordSearchForm.pageNumber = this.historyPage.pageNumber;
      this.recordSearchForm.sortName = this.historyPage.sortName;
      this.recordSearchForm.sortOrder = this.historyPage.sortOrder;
      this.api.liveLog
        .recordPageList(this.recordSearchForm)
        .then(result => {
          if (result.success) {
            this.historyPage.rows = result.data.records;
            this.historyPage.total = result.data.total;
            this.historyTableLoading = false;
          } else {
            this.$message.error(result.message);
            this.historyTableLoading = false;
          }
        })
        .catch(error => {
          this.historyTableLoading = false;
          console.log(error);
        });
    },
    enterCoursePageList() {
      this.subjectTableLoading = true;
      this.enterCourseSearchForm.studentId = this.studentId;
      this.enterCourseSearchForm.pageSize = this.subjectPage.pageSize;
      this.enterCourseSearchForm.pageNumber = this.subjectPage.pageNumber;
      this.enterCourseSearchForm.sortName = this.subjectPage.sortName;
      this.enterCourseSearchForm.sortOrder = this.subjectPage.sortOrder;
      this.api.liveLog
        .enterCoursePageList(this.enterCourseSearchForm)
        .then(result => {
          if (result.success) {
            this.subjectPage.rows = result.data.records;
            this.subjectPage.total = result.data.total;
            this.subjectTableLoading = false;
          } else {
            this.$message.error(result.message);
            this.subjectTableLoading = false;
          }
        })
        .catch(error => {
          this.subjectTableLoading = false;
          console.log(error);
        });
    },
    historyFormShow(row){
      this.studentId = row.studentId;
      this.recordPageList();
      this.historyFormVisible = true;
    },
    handleClick(tab, event) {
      if(tab.name == 'first'){
        this.recordPageList()
      }
      if(tab.name == 'second'){
        this.enterCoursePageList()
      }
    }
  },
  mounted() {
    this.pageList();
  },
  watch: {
    historyFormVisible: function(newVal) {
      if (!newVal) {
        this.historyPage.rows = [];
        this.subjectPage.rows = [];
      } else {
      }
    },
  }
};
</script>
<style scoped>
.viewRecord {
}
</style>



// WEBPACK FOOTER //
// src/components/liveInfo/viewRecord.vue